import classNames from "classnames";
import { type ReactNode } from "react";

export function SearchPanel({
  query,
  elements,
}: {
  query: string;
  elements: Record<string, ReactNode>;
}) {
  const {
    recentSearchesPlugin,
    topAuthor,
    contributors,
    series,
    articles,
    products,
    quickLinks,
  } = elements;
  const typing =
    Boolean(topAuthor || contributors || series || articles) ||
    (query.trim().length > 0 && !recentSearchesPlugin);

  return (
    <div className="cvr-container flex flex-col gap-6 pt-4 pb-8 md:grid md:grid-cols-[minmax(0,12rem)_minmax(0,1fr)_minmax(0,12rem)] md:grid-rows-[auto_1fr] md:gap-x-10 md:pt-7 md:pb-9 lg:grid-cols-[minmax(0,1fr)_minmax(0,40rem)_minmax(0,1fr)]">
      {topAuthor ? (
        <div className="md:col-start-1 md:row-start-1">{topAuthor}</div>
      ) : null}
      <div
        className={classNames(
          "min-w-0 md:col-start-2 md:row-span-2 md:row-start-1",
          { "order-3 md:order-none": !typing },
        )}
      >
        {products}
      </div>
      <div
        className={classNames(
          "flex flex-col gap-6 md:col-start-1",
          topAuthor ? "md:row-start-2" : "md:row-span-2 md:row-start-1",
          { "order-1 md:order-none": !typing },
        )}
      >
        {typing ? (
          <>
            {contributors}
            {series}
            {articles}
          </>
        ) : (
          recentSearchesPlugin
        )}
      </div>
      <div
        className={classNames("md:col-start-3 md:row-span-2 md:row-start-1", {
          "order-2 md:order-none": !typing,
        })}
      >
        {quickLinks}
      </div>
    </div>
  );
}
